import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const todoApi = createApi({
    reducerPath: "todoApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://haider-todo.herokuapp.com",
    }),
    tagTypes: ["Todo"],
    endpoints: (builder) => ({
        getTodos: builder.query({
            query: () => "/todos",
            providesTags: (result, error, arg) =>
                result
                    ? [
                          ...result.map(({ id }) => ({ type: "Todo", id })),
                          "Todo",
                      ]
                    : ["Todo"],
        }),
        addTodo: builder.mutation({
            query: (data) => ({
                url: "/todos",
                method: "POST",
                body: data,
            }),

            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg.id },
            ],
        }),
        deleteTodo: builder.mutation({
            query: (id) => ({
                url: `/todos/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg.id },
            ],
        }),
        selectColorToggle: builder.mutation({
            query: ({ id, color }) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    color,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg.id },
            ],
        }),
        toggleSelected: builder.mutation({
            query: ({ id, isCompleted }) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    completed: isCompleted,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg.id },
            ],
        }),
        updateTodo: builder.mutation({
            query: ({ id, editText }) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    text: editText,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg.id },
            ],
        }),
        completeTodos: builder.mutation({
            query: (id) => {
                return {
                    url: `/todos/${id}`,
                    method: "PATCH",
                    body: {
                        completed: true,
                    },
                };
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg },
            ],
        }),
        clearTodos: builder.mutation({
            query: (id) => {
                return {
                    url: `/todos/${id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Todo", id: arg.id },
            ],
        }),
    }),
});

export const {
    useGetTodosQuery,
    useAddTodoMutation,
    useDeleteTodoMutation,
    useSelectColorToggleMutation,
    useToggleSelectedMutation,
    useUpdateTodoMutation,
    useCompleteTodosMutation,
    useClearTodosMutation,
} = todoApi;
